import React from 'react'
import { VariantOptionProps, VLPOption } from '@storefronts/common-types'
import { TextVariantOption } from './TextVariantOption'
import {
    ColorSwatchTab,
    SwatchVariantImageContainer,
    VariantImageWrapper,
    ImageTab,
} from '../../styled/variantComponents'

interface SwatchVariantOptionProps
    extends Pick<
        VariantOptionProps,
        'value' | 'isSelected' | 'isAvailable' | 'onClick'
    > {
    option: Pick<VLPOption, 'name' | 'values'>
    valueIndex: number
    isClickable?: boolean
}

export const SwatchVariantOption: React.FC<SwatchVariantOptionProps> = ({
    option,
    value,
    valueIndex,
    isSelected: isActive,
    isAvailable,
    isClickable = true,
    onClick: onSelect,
}) => {
    const getSwatchTab = () => {
        const valueObj = option.values[valueIndex]
        if (!valueObj) return

        if (valueObj.image) {
            return (
                <ImageTab
                    imageUrl={valueObj.image}
                    active={false}
                    available={isAvailable}
                    isClickable={isClickable}
                    isSwatch={true}
                />
            )
        }

        if (valueObj.color) {
            return (
                <ColorSwatchTab
                    colorValue={valueObj.color}
                    active={false}
                    available={isAvailable}
                    isClickable={isClickable}
                    isSwatch={true}
                />
            )
        }

        return
    }

    const swatchTab = getSwatchTab()
    if (swatchTab) {
        return (
            <SwatchVariantImageContainer
                isActive={isActive}
                isAvailable={isAvailable}
                isClickable={isClickable}
                onClick={onSelect}
                role="radio"
                aria-checked={isActive}
                aria-disabled={!isClickable}
                aria-label={`${option.name}: ${value}`}
                data-testid={`swatch-variant-${value}`}
            >
                <VariantImageWrapper isSwatch={true}>
                    {swatchTab}
                </VariantImageWrapper>
            </SwatchVariantImageContainer>
        )
    }

    return (
        <TextVariantOption
            value={value}
            isSelected={isActive}
            isAvailable={isAvailable}
            isClickable={isClickable}
            onClick={onSelect}
        />
    )
}
